<script lang="ts">
  import { Alert } from '$shared/components';
  import Label from '$provider/constants/Label';
  import UIDisclaimer from '$provider/constants/UIDisclaimer';
  import { AlertOption } from '$provider/models/AlertOption';

  interface Props {
    onclick?: () => void;
  }

  let { onclick }: Props = $props();
</script>

<div class="alert-out-date">
  <Alert
    data={UIDisclaimer.ProfileMergeInfoNotUptoDate}
    options={AlertOption.warnAlert(true, Label.Refresh)}
    maxWidth
    {onclick}
  />
</div>
